import React, { useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Accordion, Card } from "react-bootstrap";
import PropTypes from "prop-types";

import { FieldRenderer } from "../../CustomFields";
import { allSensorParameters, allSensors } from "../../../../selector/common";
import { convertToOptions, getSelectedSensorParameters } from "../../../../helpers";
import CustomSelect from "../../../../Pages/Containers/CustomSelect"; // Assuming CustomSelect is exported as default
import { get } from "lodash";

const Parameters = ({
  name,
  values,
  errors,
  touched,
  submitCount,
  allSensors,
  allSensorParameters,
  setFieldValue,
}) => {
  const [sensorParameters, setSensorParameters] = useState([{ sensor_id: "", parameter_id: "" }]);
  const [activeKey, setActiveKey] = useState(0);

  const handleSensorChange = (index, sensorId) => {
    const newSensorParamsState = [...sensorParameters];
    newSensorParamsState[index].sensor_id = sensorId;
    newSensorParamsState[index].parameter_id = "";
    setSensorParameters(newSensorParamsState);
    setFieldValue(`${name}[${index}].sensor_id`, sensorId);
    setFieldValue(`${name}[${index}].parameter_id`, "");
  };

  const handleParameterChange = (index, parameterId) => {
    const newSensorParamsState = [...sensorParameters];
    newSensorParamsState[index].parameter_id = parameterId;
    setSensorParameters(newSensorParamsState);
    setFieldValue(`${name}[${index}].parameter_id`, parameterId);
  };

  const addSensorParameter = async () => {
    await setSensorParameters([...sensorParameters, { sensor_id: "", parameter_id: "" }]);
    setActiveKey(sensorParameters.length);
  };

  const removeSensorParameter = (index) => {
    const newSensorParamsState = sensorParameters.filter((_, i) => i !== index);
    setSensorParameters(newSensorParamsState);
    setFieldValue(name, newSensorParamsState);
    setActiveKey(sensorParameters.length - 1);
  };

  const handleActivateKey = (index) => {
    setActiveKey(index);
  };

  return (
    <div className="search-bar mb-0">
      <Accordion defaultActiveKey="0" activeKey={activeKey.toString()}>
        {sensorParameters.map((sensorParameter, index) => {
          const prefixName = `${name}[${index}]`;
          return (
            <Accordion.Item
              key={index}
              eventKey={index.toString()}
              onClick={() => handleActivateKey(index)}
            >
              <Accordion.Header>Parameter {index + 1}</Accordion.Header>
              <Accordion.Body>
                <Card.Body>
                  <Row>
                    <Col sm="12" className="mt-2">
                      <FieldRenderer
                        as={CustomSelect}
                        label="Sensors"
                        name={`${prefixName}.sensor_id`}
                        options={convertToOptions(allSensors, "sensor_id", "title")}
                        //value={sensorParameter.sensor_id}
                        value={get(values, `${prefixName}.sensor_id`)}
                        onChange={(value) => handleSensorChange(index, value)}
                        labelwidth={12}
                        inputwidth={12}
                        required
                        error={get(errors, `${prefixName}.sensor_id`)}
                        touched={get(touched, `${prefixName}.sensor_id`)}
                        submitcount={submitCount}
                      />
                    </Col>
                    <Col sm="12">
                      <FieldRenderer
                        as={CustomSelect}
                        label="Parameters"
                        name={`${prefixName}.parameter_id`}
                        options={convertToOptions(
                          getSelectedSensorParameters(
                            sensorParameter.sensor_id,
                            allSensors,
                            allSensorParameters
                          ),
                          "parameter_id",
                          "title"
                        )}
                        //value={sensorParameter.parameter_id}
                        value={get(values, `${prefixName}.parameter_id`)}
                        onChange={(value) => handleParameterChange(index, value)}
                        labelwidth={12}
                        inputwidth={12}
                        required
                        error={get(errors, `${prefixName}.parameter_id`)}
                        touched={get(touched, `${prefixName}.sensor_id`)}
                        submitcount={submitCount}
                      />
                    </Col>
                  </Row>
                  {sensorParameters.length !== 1 && (
                    <div className="text-center">
                      <button
                        className="mt-2 p-2 pointer link link-danger link-button"
                        onClick={() => removeSensorParameter(index)}
                      >
                        <i className="bx bx-trash"></i>
                        Remove parameter
                      </button>
                    </div>
                  )}
                </Card.Body>
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
      <div className="text-center">
        <button
          className="mt-2 p-2 pointer link link-success link-button"
          onClick={addSensorParameter}
        >
          <i className="bx bx-add"></i>
          Add parameter
        </button>
      </div>
    </div>
  );
};

// PropTypes validation
Parameters.propTypes = {
  allSensors: PropTypes.array.isRequired,
  allSensorParameters: PropTypes.array.isRequired,
  // Add PropTypes validation for Formik props
  name: PropTypes.string,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  setFieldValue: PropTypes.func,
  touched: PropTypes.object,
  errors: PropTypes.object,
  submitCount: PropTypes.number,
};

const mapStateToProps = (state) => ({
  allSensors: allSensors(state),
  allSensorParameters: allSensorParameters(state),
});

export default connect(mapStateToProps)(Parameters);
